import React from 'react';

interface ChatButtonProps {
  onClick: () => void;
  isOpen: boolean;
  hasUnreadMessages?: boolean;
}

export function ChatButton({ onClick, isOpen, hasUnreadMessages = false }: ChatButtonProps): React.ReactElement {
  return (
    <>
      <style>{`
        @keyframes slowPulse {
          0%, 100% {
            opacity: 0.2;
            transform: scale(1);
          }
          5% {
            opacity: 0.4;
            transform: scale(1.1);
          }
          10% {
            opacity: 0.2;
            transform: scale(1);
          }
        }
        .slow-pulse {
          animation: slowPulse 15s ease-in-out infinite;
        }
      `}</style>
      <button
        onClick={onClick}
        className={`fixed bottom-6 right-6 w-16 h-16 rounded-full shadow-lg transition-all duration-300 ${
          isOpen
            ? 'bg-gray-700 hover:bg-gray-800 ring-4 ring-indigo-500 ring-opacity-50'
            : 'bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 hover:scale-110'
        } flex items-center justify-center z-50`}
        aria-label={isOpen ? 'Close Requirements Assistant' : 'Open Requirements Assistant'}
      >
        {isOpen ? (
          // Close icon when chat is open
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          // AI icon when chat is closed
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        )}

        {/* Unread messages badge */}
        {hasUnreadMessages && !isOpen && (
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 border-2 border-white rounded-full flex items-center justify-center">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
          </div>
        )}

        {/* Pulse animation ring when closed - pulses every 15 seconds */}
        {!isOpen && (
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-indigo-600 to-blue-600 slow-pulse"></div>
        )}
      </button>
    </>
  );
}

export default ChatButton;
